// extracted by mini-css-extract-plugin
export var currentStep = "_ig-2";
export var nodeCard = "_ig-0";
export var pathHighlighted = "_ig-1";